import getLanguage from '../../selectors/view/get-language';

const setLang = state => {
  const tag = document.getElementsByTagName('HTML')[0];
  tag.lang = getLanguage(state);
};

export default setLang;
